module.exports = __webpack_public_path__ + "img/filters-ductwork-cleaned-02-xlarge.fb1fcf3d.jpg";